<template>
  <div class="flow-wrap" v-if="stepList.id">
    <div class="flow-title">
      <span>服务流程</span>
    </div>
    <div
      class="flow-list"
      v-if="stepList.serviceProcessInstanceVOList.length > 0"
    >
      <div
        style="display: flex"
        v-for="(item, index) in stepList.serviceProcessInstanceVOList"
        :key="index"
      >
        <div class="flow-item" :style="getItemWidth(item)">
          <div class="step-title">{{ item.serviceProcessVO.name }}</div>

          <!-- 新增：主节点+连接线包裹层，精准对齐 -->
          <div class="main-node-box">
            <div class="node" :class="[getStatusText(item.status)]"></div>
            <!-- 中间连接线 -->
            <div
              v-if="stepList.serviceProcessInstanceVOList.length !== index + 1"
              class="line-h"
              :class="getLineClass(item.status)"
              :style="{ width: getLineWidth(index) }"
            ></div>
          </div>
          <div
            class="sub-node-group"
            v-if="
              item.serviceNodeInstanceVOList &&
              item.serviceNodeInstanceVOList.length
            "
          >
            <!-- 主垂直线 -->
            <div class="main-vertical-line"></div>
            <!-- 水平基座线 -->
            <div class="base-horizontal-line"></div>
            <!-- 子节点 -->
            <div class="sub-items-wrapper">
              <div
                class="sub-item"
                v-for="(child, i) in item.serviceNodeInstanceVOList"
                :key="i"
                @click="handClick(child)"
              >
                <div class="sub-vertical-line"></div>

                <div
                  class="sub-node"
                  :class="getStatusText(child.status)"
                ></div>
                <div class="sub-title">
                  {{ child.serviceNodeVO.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :dialogStyle="dialogData.dialogStyle"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @changeFlag="changeFlag"
        @addProjectRecord="addProjectRecord"
        @handleCloudAvatarSuccess="handleCloudAvatarSuccess"
        @remoteMethod2="remoteMethod2"
      ></my_dialog7>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
    stepList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      baseInfo: {},
      flowList: {},
      centerDistanceList: [], // 存储每一组相邻节点中心距离
      dialogData: {
        flag: false,
        width: "30%",
        title: "查看支出附件",
        buttonArray: [
          {
            text: "取消",
            active: "cancel",
          },
        ],
        data: [
          {
            title: "",
            type: "show_img",
            value: "",
          },
        ],
        dialogStyle: {},
      },
      tempNodeData: {},
      nodeUserInfo: {},
      clientTagList: [],
      clientNumberList: [],
      disabled: false,
      searchData: {
        date: [],
      },
    };
  },
  watch: {
    enterpriseInfo: {
      handler(newVal, oldVal) {
        this.enterpriseInfo = newVal;
      },
      deep: true,
    },
  },
  methods: {
    getClientTip() {
      let requestData = {
        type: ["客户标签"],
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/getTagList",
        requestData,
        (data) => {
          if (data.length > 0) {
            data.forEach((item) => {
              if (item.type === "客户标签") {
                this.clientTagList = item.value;
              }
            });
          }

          this.getClientNum();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    getClientNum() {
      this.$request(
        "get",
        "/dataDictionary/queryClientNumber",
        {},
        (data) => {
          this.clientNumberList = data;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取所有相邻flow-item中心间距
    getItemCenterDistances() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const items = document.querySelectorAll(".flow-item");
          const distArr = [];
          for (let i = 0; i < items.length - 1; i++) {
            const curr = items[i].getBoundingClientRect();
            const next = items[i + 1].getBoundingClientRect();
            // 两元素中心X差值 = 中心间距
            const currCenterX = curr.left + curr.width / 2;
            const nextCenterX = next.left + next.width / 2;
            distArr.push(nextCenterX - currCenterX);
          }
          resolve(distArr);
        });
      });
    },
    // 核心：根据子节点数量计算当前步骤的最小宽度
    getItemWidth(item) {
      if (
        !item.serviceNodeInstanceVOList ||
        item.serviceNodeInstanceVOList.length === 0
      ) {
        return { minWidth: "120px" };
      }
      // 每个子节点 50px + 间距16px + 左右留白20px
      const childWidth = 50;
      const gap = 16;
      const total =
        item.serviceNodeInstanceVOList.length * (childWidth + gap) + 40;
      return {
        minWidth: total + "px",
      };
    },
    // 状态映射：将数字枚举转换为字符串状态
    getStatusText(status) {
      const statusMap = {
        0: "wait",
        1: "process",
        2: "finish",
      };
      return statusMap[status] || "wait";
    },
    // 连接线状态样式
    getLineClass(status) {
      const statusText = this.getStatusText(status);
      return {
        "line-wait": statusText === "wait",
        "line-process": statusText === "process",
        "line-finish": statusText === "finish",
      };
    },
    // 动态获取当前索引对应的连接线宽度
    getLineWidth(index) {
      if (!this.centerDistanceList[index]) return "60px";
      // 减去节点自身占位偏移，微调适配视觉
      return `${this.centerDistanceList[index]}px`;
    },
    handClick(item) {
      this.tempNodeData = item;
      this.nodeUserInfo = {};
      // 1. 校验当前用户是否有权限操作结点
      this.$request(
        "get",
        `/serviceNodeInstanceUser/verifyUserOperationPermission?clientId=${this.clientInfo.id}&userId=${this.baseInfo.userId}&serviceNodeInstanceId=${this.tempNodeData.id}`,
        {},
        (data) => {
          if (data) {
            // 有操作权限 检查是否有填写过节点信息 如果有 做修改 如果没有 新增
            if (
              this.tempNodeData.serviceNodeInstanceUserVOList &&
              this.tempNodeData.serviceNodeInstanceUserVOList.length > 0
            ) {
              this.tempNodeData.serviceNodeInstanceUserVOList.forEach(
                (item) => {
                  if (item.userId == this.baseInfo.userId) {
                    // 找到自己的节点信息
                    this.nodeUserInfo = JSON.parse(JSON.stringify(item));

                    if (this.nodeUserInfo.attachment) {
                      this.nodeUserInfo.attachment = JSON.parse(
                        this.nodeUserInfo.attachment,
                      );
                    }
                  }
                },
              );
            }
            this.$request(
              "get",
              `/serviceNodeInstance/getClientRoleUser?id=${this.tempNodeData.id}&clientId=${this.clientInfo.id}`,
              {},
              (data) => {
                if (data.length > 0) {
                  this.tempNodeData.executorList = data;
                  // this.nodeUserInfo
                  this.tempNodeData.executorList.forEach((item) => {
                    item.userList.forEach((it) => {
                      // 检查当前用户是否在角色中 且 角色状态为1
                      if (
                        item.roleStatus == 1 &&
                        it.userId == this.baseInfo.userId
                      ) {
                        // 给自己节点信息赋值角色状态
                        this.nodeUserInfo.roleStatus = 1;
                      }
                    });
                  });
                }
                this.editNodeInfo();
              },
              (errorMessage) => {
                this.$message.error(errorMessage);
              },
            );
          } else {
            // 3. 没有操作权限 提示用户
            this.$message.error("当前节点暂无权限操作!");
            return;
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    drawerOper(active) {
      let flag = false;
      let requestData = {};
      switch (active) {
        // 完成步骤
        case "save_node":
          // 检查是否有填写过节点信息 如果有 做修改 如果没有 新增
          let url = "";
          if (this.nodeUserInfo.id) {
            url = "/serviceNodeInstanceUser/modify";
          } else {
            url = "/serviceNodeInstanceUser/add";
          }
          requestData = {
            id: this.nodeUserInfo.id,
            clientId: this.clientInfo.id, // 客户id
            userId: this.baseInfo.userId, // 用户id
            userName: this.baseInfo.userName, // 用户名
            serviceNodeInstanceId: this.tempNodeData.id, // 节点id
            clientForm: {},
          };
          this.dialogData.data.forEach((item) => {
            if (item.key == "attachment") {
              requestData[item.key] = JSON.stringify(item.value.value);
            } else if (item.key == "scheduleTime") {
              requestData.scheduleStartTime = item.value[0];
              requestData.scheduleEndTime = item.value[1];
            } else if (item.client == "clientForm") {
              if (item.key == "tip") {
                requestData[item.client][item.key] = JSON.stringify(item.value);
              } else {
                requestData[item.client][item.key] = item.value;
              }
            } else if (item.key == "wechatGroupId") {
              if (item.value) {
                requestData[item.key] = item.value;
              } else {
                requestData[item.key] = "-1";
              }
            } else if (item.key) {
              requestData[item.key] = item.value;
            }
          });
          if (requestData.isSchedule == 1) {
            if (
              !requestData.scheduleStartTime ||
              !requestData.scheduleEndTime
            ) {
              this.$message.error("请选择日程时间");
              return;
            }
          } else {
            // 没有日程 清空日程时间
            requestData.scheduleStartTime = "";
            requestData.scheduleEndTime = "";
          }
          if (requestData.wechatGroupId) {
            requestData.status = 1;
          }
          console.log("requestData", requestData);
          this.$request(
            "post",
            url,
            requestData,
            (data) => {
              this.$message.success("保存成功!");
              this.colseDialog();
              this.$emit("refreshClientData");
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    changeFlag(val) {
      // 1. 找到 id 为 2 的元素索引
      const index = this.dialogData.data.findIndex(
        (item) => item.title === "创健日程",
      );
      const index2 = this.dialogData.data.findIndex(
        (item) => item.title === "日程时间",
      );
      // 2. 如果找到了，就在它后面插入新元素
      if (index !== -1) {
        if (val == 1) {
          // splice(插入位置, 删除0个, 插入元素)
          if (index2 !== -1) {
            this.dialogData.data.splice(index2, 1);
          }
          this.dialogData.data.splice(index + 1, 0, {
            type: "time_date_scope",
            title: "日程时间",
            key: "scheduleTime",
            value: [],
            required: true,
            pickerOptions: {
              disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7;
              },
            },
          });
        } else if (val == 0) {
          this.dialogData.data.splice(index + 1, 1);
        }
      }
    },
    // 新增节点信息
    editNodeInfo() {
      // 3. 调接口查 节点记录数据
      this.$request(
        "get",
        `/serviceNodeInstanceUserMessageRecord/queryListByServiceNodeInstanceId?serviceNodeInstanceId=${this.tempNodeData.id}`,
        {},
        (data) => {
          data.forEach((item) => {
            if (item.attachment) {
              item.attachment = JSON.parse(item.attachment);
            }
          });
          this.dialogData.width = "650px";
          this.dialogData.title = `服务节点: ${this.tempNodeData.serviceNodeVO.name}`;
          this.dialogData.dialogStyle = {
            flexDirection: "row",
            flexWrap: "wrap",
          };
          this.dialogData.buttonArray = [
            {
              text: "保存",
              active: "save_node",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              type: "line-text",
              text: "节点信息",
            },
            {
              title: "执行人员",
              type: "executor-list",
              value: this.tempNodeData.executorList,
            },
            {
              title: "服务要求",
              type: "text",
              value: this.tempNodeData.serviceNodeVO.requiredInfo,
            },
            {
              title: "服务内容",
              type: "text",
              value: this.tempNodeData.serviceNodeVO.description,
            },
            {
              width: "46%",
              title: "是否完成",
              type: "checkBox",
              key: "status",
              text: "已完成",
              value: this.nodeUserInfo.status ? 1 : 0,
              trueLabel: 1,
              falseLabel: 0,
              disabled: false,
            },
            {
              width: "46%",
              title: "创健日程",
              type: "radio",
              key: "isSchedule",
              value: 0,
              options: [
                {
                  label: "是",
                  value: 1,
                },
                {
                  label: "否",
                  value: 0,
                },
              ],
            },
            {
              title: "上传附件",
              type: "upload_cloud_file",
              value: {
                value: this.nodeUserInfo.attachment || "",
                action: this.$fileBaseurl + "/uploadImageByMultipartFile",
                headers: {
                  token: "95931b371eb64f4a9c862983ca8a5d15",
                },
                uploadParameter: {
                  systemName: "finance",
                  title: "服务节点附件",
                },
              },
              flag: false,
              key: "attachment",
            },
            {
              type: "line-text",
              text: "节点记录",
            },
            {
              title: "",
              type: "projectRecord",
              value: {
                list: data,
              },
            },
          ];
          // 1. 判断当前角色节点是否是创健日程 如果是 展示日程时间选择器
          if (
            this.nodeUserInfo.scheduleStartTime &&
            this.nodeUserInfo.scheduleEndTime
          ) {
            const index = this.dialogData.data.findIndex(
              (item) => item.title === "创健日程",
            );
            // 创健日程 的节点 改为 是
            this.dialogData.data[index].value = 1;
            this.dialogData.data.splice(index + 1, 0, {
              type: "time_date_scope",
              title: "日程时间",
              key: "scheduleTime",
              value: [
                this.nodeUserInfo.scheduleStartTime,
                this.nodeUserInfo.scheduleEndTime,
              ],
              required: true,
            });
          }
          // 节点已完成 或者 当前人的步骤已完成 禁用所有输入框
          this.disabled = false;
          if (
            this.tempNodeData.status == 2 ||
            this.nodeUserInfo.status == 1 ||
            this.nodeUserInfo.roleStatus == 1
          ) {
            this.disabled = true;
          }
          // 2. 判断当前角色节点完成状态 如果已完成 不展示保存按钮 同时 将 是否完成 创健日程 日程时间改为禁用状态
          if (this.disabled) {
            this.dialogData.data.forEach((item) => {
              if (item.key == "status") {
                item.disabled = true;
              }
              if (item.key == "isSchedule") {
                item.flag = true;
              }
              if (item.key == "scheduleTime") {
                item.disabled = true;
              }
              if (item.key == "attachment") {
                item.flag = true;
              }
            });
          }

          // 3. 如果是特殊类型 添加完善信息
          if (this.tempNodeData.serviceNodeVO.personalFunctionCode) {
            const index = this.dialogData.data.findIndex(
              (item) => item.title === "服务内容",
            );
            this.dialogData.data.splice(
              index + 1,
              0,
              ...this.getPersonalFunctionCode(),
            );
          }
          this.dialogData.data.flag = true;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
      this.dialogData.flag = true;
    },
    getPersonalFunctionCode() {
      let data = [];
      // 1. 先将字符串转换为数组
      let list =
        this.tempNodeData.serviceNodeVO.personalFunctionCode.split(",");
      // 2. 遍历数组 根据code添加对应的输入框
      list.forEach((item) => {
        switch (item) {
          case "clientNum":
            // 客户编号
            data.push({
              title: "客户编号",
              type: "select",
              key: "clientNum",
              client: "clientForm",
              value: this.enterpriseInfo.clientInfo.clientNum,
              // options: this.clientNumberList,
              // flag: this.disabled,
              // placeholder: "请输入关键词以搜索客户编号",
              // loading: false,
              options: this.clientNumberList,
            });
            break;
          case "enterpriseNumber":
            // 客户税号
            data.push({
              title: "客户税号",
              type: "input",
              key: "enterpriseNumber",
              client: "clientForm",
              value: this.enterpriseInfo.clientInfo.enterpriseNumber,
              // flag: this.disabled,
            });
            break;
          case "physicalAddress":
            // 实际地址
            data.push({
              title: "实际地址",
              type: "input",
              key: "physicalAddress",
              client: "clientForm",
              value: this.enterpriseInfo.clientInfo.physicalAddress,
              // flag: this.disabled,
            });
            break;
          case "bankInfo":
            // 开户行信息
            data.push(
              {
                width: "46%",
                title: "开户行",
                type: "input",
                key: "bankName",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.bankName,
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "银行账号",
                type: "input",
                key: "bankAccount",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.bankAccount,
                // flag: this.disabled,
              },
            );
            break;
          case "moduleTag":
            // 模块标签管理
            data.push(
              {
                width: "46%",
                title: "开票客户",
                type: "radio",
                key: "isInvoicing",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isInvoicing,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "包含社保",
                type: "radio",
                key: "isSocialSecurity",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isSocialSecurity,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "包含流水",
                type: "radio",
                key: "isStatement",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isStatement,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "包含园区",
                type: "radio",
                key: "isTaxPark",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isTaxPark,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "账本装订",
                type: "radio",
                key: "isBookbinding",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isBookbinding,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                width: "46%",
                title: "包含财务数据",
                type: "radio",
                key: "isFinancialData",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isFinancialData,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
              {
                title: "合规客户",
                type: "radio",
                key: "isSuitableClient",
                client: "clientForm",
                value: this.enterpriseInfo.clientInfo.isSuitableClient,
                options: [
                  {
                    label: "是",
                    value: "Y",
                  },
                  {
                    label: "否",
                    value: "N",
                  },
                ],
                // flag: this.disabled,
              },
            );
            break;
          case "tip":
            // 客户标签
            data.push({
              title: "客户标签",
              type: "select",
              key: "tip",
              client: "clientForm",
              value: this.enterpriseInfo.clientInfo.tip,
              options: this.clientTagList,
              multiple: true,
              // flag: this.disabled,
            });
            break;
          case "wechatBinding":
            // 企业微信群绑定
            data.push({
              title: "企微绑定crm",
              key: "wechatGroupId",
              type: "select-filterable",
              value: this.enterpriseInfo.clientInfo.wechatGroupId,
              placeholder: "请输入关键词以搜索企业微信群名称",
              loading: false,
              options: [
                {
                  label: this.enterpriseInfo.clientInfo.wechatGroupName,
                  value: this.enterpriseInfo.clientInfo.wechatGroupId,
                },
              ],
            });
            break;
          default:
            break;
        }
      });
      return data;
    },
    colseDialog() {
      this.dialogData.flag = false;
      this.dialogData.data = [];
    },
    // 添加节点记录
    addProjectRecord(textarea) {
      let requestData = {
        serviceNodeInstanceId: this.tempNodeData.id,
        userId: this.baseInfo.userId,
        userName: this.baseInfo.userName,
        type: "0", // 类型 0-文本
        content: textarea, // 文本内容
      };
      this.$request(
        "post",
        "/serviceNodeInstanceUserMessageRecord/add",
        requestData,
        (data) => {
          this.$message.success("添加成功!");
          this.dialogData.data.forEach((item) => {
            if (item.type == "projectRecord") {
              // 往数组第一位追加
              item.value.list.unshift({
                userId: this.baseInfo.userId,
                userName: this.baseInfo.userName,
                content: textarea,
                gmtCreate: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"),
              });
            }
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    handleCloudAvatarSuccess(active, setData) {
      switch (active) {
        case "uploadCloudFile":
          // 上传文件
          this.dialogData.data.forEach((item) => {
            if (item.title == "上传附件") {
              item.value.value = setData.result;
            }
          });
          this.$message.success("上传成功!");
          break;
        default:
          break;
      }
    },
    remoteMethod2(data) {
      data.item.loading = true;
      let requestData = {
        groupName: data.query, // 企业微信群名称
        userId: this.baseInfo.userId,
        isBind: "0", // 0=未绑定, 1=已绑定
        currentPage: 1,
        pageSize: 10,
      };
      this.$request(
        "post",
        "/chatGroup/query",
        requestData,
        (responseData) => {
          data.item.options = responseData.records.map((it) => {
            return {
              label: it.groupName,
              value: it.groupId,
            };
          });
          data.item.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
      // const index = this.dialogData.data.findIndex(
      //   (item) => item.title === "客户编号",
      // );
      // this.dialogData.data[index].loading = true;
      // setTimeout(() => {
      //   this.dialogData.data[index].options = this.clientNumberList.filter(
      //     (item) => item.label.includes(query),
      //   );
      //   console.log(this.dialogData.data[index].options);
      //   this.dialogData.data[index].loading = false;
      // }, 200);
    },
  },
  async mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getClientTip();
    this.centerDistanceList = await this.getItemCenterDistances();
  },
};
</script>

<style lang="less" scoped>
/* ========== 容器基础 ========== */
.flow-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 24px;
  box-sizing: border-box;
}

.flow-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.5px;

  .title-search {
    display: flex;
    .title-search-item {
      width: 200px;
      margin-left: 8px;
    }
  }
}

/* ========== 横向滚动容器 ========== */
.flow-list {
  width: 100%;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 8px;
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #cbd5e1;
    transition: background 0.2s ease;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
    cursor: pointer;
  }
}

/* ========== 单个流程项 ========== */
.flow-item {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  /* 核心：根据子节点自动宽度，不固定 */
  width: auto;
  min-width: 120px;
  // flex-shrink: 0;
  transition: all 0.3s ease;
}

.step-title {
  font-size: 13px;
  color: #334155;
  margin-bottom: 12px;
  text-align: center;
}

/* 主节点+连接线包裹：核心修复对齐精度 */
.main-node-box {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* ========== 主节点样式 ========== */
.node {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
  z-index: 10;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  box-sizing: border-box;
  border: 2px solid transparent;
  background-clip: padding-box;
  &:hover {
    transform: scale(1.15);
    filter: brightness(1.1);
  }
}

/* 状态配色 - 简约高级体系 */
.node.wait {
  background-color: #f87171;
  border-color: #fca5a5;
  box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.15);
  animation: pulse-wait 2s infinite ease-in-out;
}

.node.process {
  background-color: #f59e0b;
  border-color: #fbbf24;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.15);
  animation: pulse-process 2s infinite ease-in-out;
}

.node.finish {
  background-color: #67c23a;
  border-color: #85ce61;
}

/* 等待中呼吸动画 */
@keyframes pulse-wait {
  0% {
    box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.15);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(248, 113, 113, 0);
  }
  100% {
    box-shadow: 0 0 0 4px rgba(248, 113, 113, 0);
  }
}

/* 进行中呼吸动画 */
@keyframes pulse-process {
  0% {
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.15);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0);
  }
  100% {
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0);
  }
}

/* ========== 横向连接线 ========== */
.line-h {
  height: 2px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
  border-radius: 1px;
}

/* 连接线状态分层 */
.line-wait {
  background: #f87171;
}

.line-process {
  background: #fbbf24;
}

.line-finish {
  background-color: #67c23a;
}

/* ========== 子节点树结构 ========== */
.sub-node-group {
  position: relative;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
}

/* 主垂直线 */
.main-vertical-line {
  width: 1px;
  height: 32px;
  background-color: #e2e8f0;
  margin: 0 auto;
}

/* 水平基座线 */
.base-horizontal-line {
  width: calc(100% - 64px); /* 减去两端各29px（子节点半径25px + 间距3px） */
  height: 1px;
  background-color: #e2e8f0;
  position: relative;
}

/* 子节点包装器 */
.sub-items-wrapper {
  display: flex;
  gap: 15px;
  position: relative;
  margin-top: 0;
}

/* 子节点垂直线 */
.sub-vertical-line {
  width: 1px;
  height: 24px;
  margin: 0 auto;
  background-color: #e2e8f0;
  transition: background-color 0.3s ease;
}

/* 子节点圆点 */
.sub-node {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 2px solid transparent;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background-clip: padding-box;
}

/* 子节点状态 - 与主节点视觉统一 */
.sub-node.wait {
  background: #f87171;
  border-color: #fca5a5;
}

.sub-node.process {
  background: #fbbf24;
  border-color: #fcd34d;
}

.sub-node.finish {
  background: #67c23a;
  border-color: #85ce61;
}

.sub-item:hover .sub-node {
  transform: scale(1.08);
  filter: brightness(1.1);
}

/* 子节点标题 */
.sub-title {
  margin-top: 8px;
  font-size: 11px;
  color: #64748b;
  text-align: center;
  width: 65px;
  line-height: 1.3;
  word-break: break-all;
  transition: color 0.2s ease;
  &:hover {
    color: #333;
  }
}

/* 单个子项 */
.sub-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
}
</style>
